import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  input: {
    display: 'none',
  },
}));

export default useStyles;
